import React from 'react';
import Helmet from 'react-helmet';

import { Section } from '../Section';
import { BokaBord } from './BokaBord';

export const BookSection = ({
  bigImage,
  heading,
  marketingActivated,
  marketing,
  scrollToRef,
  active,
  slug,
}) => [
  active && (
    <Helmet key="helmet">
      <meta property="og:url" content={`https://www.styrelsen.nu/${slug}`} />
    </Helmet>
  ),
  <Section
    key="section"
    heading={heading}
    marketing={marketingActivated && marketing}
    image={bigImage}
    scrollToRef={scrollToRef}
  />,
  <BokaBord key="bokabord" />,
];



// WEBPACK FOOTER //
// ./app/components/BookSection/BookSection.js